import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Root = () => {
    const [redirectUrl, setRedirectUrl] = useState('');

    useEffect(() => {
        // Check if the hostname contains 'enterprise' subdomain
        const hostname = window.location.hostname;
        const isEnterprise = hostname.startsWith('enterprise.') || hostname.startsWith('enterprise-sandbox.');
        
        // Set the appropriate redirect URL based on subdomain
        if (isEnterprise) {
            setRedirectUrl('home/enterprise-dashboard');
        } else {
            setRedirectUrl('analytics/shipments');
        }
    }, []);

    // Don't render the Navigate component until we've determined the URL
    if (!redirectUrl) {
        return null; // Or a loading component if preferred
    }

    return <Navigate to={`/${redirectUrl}`} />;
};

export default Root;
